module.exports = __webpack_public_path__ + "img/portal-samp-votable.472b4370.jpg";